import { Container } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "./navigation-bar.scss";

function NavigationBarAtom(props) {
	const { children } = props;
	return (
		<Navbar bg="light" variant="light" className="text-body grey-grad">
			<Container fluid>
				<Nav className="me-auto text-uppercase text-body">
					{children}
				</Nav>
			</Container>
		</Navbar>
	);
}

export default NavigationBarAtom;
